import React from "react";
import Layout from "../containers/Layout";
import { Call } from "./CallComponents";
import { isAfter } from "date-fns";


const getCallStatus = (pageContext) => {
  const {
    event: { conference_date, audio_file },
    isApproved,
    optOut,
  } = pageContext;
  if (optOut) {
    return "opt-out";
  }
  const conferenceDate = new Date(conference_date);
  const today = new Date();
  if (!audio_file || !isApproved) {
    if (isAfter(conferenceDate, today)) {
      return "scheduled";
    }
    if (isApproved) {
      return "missing-audio";
    }
    return "awaiting-approval";
  }
  return "available";
};

const CallExport = (props) => {
  const { pageContext } = props;
  const {
    exchange,
    symbol,
    event: { year, quarter },
  } = pageContext;
  const callStatus = getCallStatus(pageContext);
  const layoutProps = {
    ...props,
    analyticsOptions: {
      exchange,
      symbol,
      year,
      quarter,
      callStatus,
    }
  };

  return (
    <Layout {...layoutProps}>
      <Call {...props} />
    </Layout>
  );
};

export default CallExport;
